import { capitalize } from 'lodash';

import { Text } from '@/components/text';
import { LocationInterface, RouteLocationInterface } from '@/types';
import { SegmentModeType } from '@/types/api-types';
import { convertModeToPortType, formatDistance } from '@/utils/format';
import { getCountryName } from '@/utils/format/route-location';
import { isPlaceCountry } from '@/utils/places';
import { tv } from '@/utils/styles';

interface Props {
  location: Pick<RouteLocationInterface, 'identifiers' | 'countryCode' | 'name'>;
  mode: SegmentModeType;
  targetLocation?: LocationInterface;
  distance?: number;
  showPrompt?: boolean;
}

const PortTooltip = ({ location, mode, distance, showPrompt = true, targetLocation }: Props) => {
  const { name, countryCode } = location;
  const portType = convertModeToPortType(mode);
  const countryName = getCountryName(countryCode);
  const targetLocationIsCountry = targetLocation ? isPlaceCountry(targetLocation) : false;

  const { base, distanceText, dl, dt, dd, separator, promptText } = styles();

  return (
    <div className={base()}>
      <Text variant="secondary" className="m-0 mb-1 font-medium">
        {name}
      </Text>
      {distance && targetLocation && !targetLocationIsCountry && (
        <Text variant="sm" className={distanceText()}>
          {formatDistance(distance)} by road from {targetLocation.name}
        </Text>
      )}
      <dl className={dl()}>
        <dt className={dt()}>Country</dt>
        <dd className={dd()}>{countryName}</dd>
      </dl>
      <dl className={dl()}>
        <dt className={dt()}>Type</dt>
        <dd className={dd()}>{capitalize(portType)}</dd>
      </dl>
      <span className={separator()} />
      {showPrompt && (
        <Text variant="sm" className={promptText()}>
          Click for more details
        </Text>
      )}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'min-w-[220px] max-w-[260px] p-2 text-left',
    distanceText: 'mb-2 mt-1 italic text-white',
    dl: 'm-0 flex',
    dt: 'm-0 min-w-16 p-0 opacity-60',
    dd: 'm-0 p-0',
    separator: 'my-2 block w-full border-t border-white/[0.06]',
    promptText: 'm-0 mt-1 italic text-grey-400',
  },
});

export { PortTooltip };
